import React from 'react';
import { Stack, Typography } from '@mui/material';
import { capitalizeFirstLetter } from 'formatters';
import { green, red, yellow } from '@mui/material/colors';

import { ReportsListingViewModel } from '../../../types';

interface Props {
  row: ReportsListingViewModel;
}

export const StageCell = ({ row }: Props) => {
  const getColorByDays = (days: number) => {
    if (days <= 5) return green[600];
    if (days <= 10) return yellow[600];
    return red[600];
  };

  return (
    <Stack width="100%" direction="row" justifyContent="space-between">
      <Stack>
        <Typography>{row.stage}</Typography>
        {row.department && (
          <Typography variant="caption" color="textDisabled">
            {capitalizeFirstLetter(row.department)}
          </Typography>
        )}
      </Stack>
      <Stack>
        {row.closeStatus ? (
          <Typography
            sx={{
              borderRadius: '0.4rem',
              padding: '0.1rem 0.2rem',
              backgroundColor: row.closeStatus === 'SUCCESS' ? green[50] : red[50],
            }}
            color={row.closeStatus === 'SUCCESS' ? 'green' : 'red'}
          >
            {row.closeStatus === 'SUCCESS' ? 'Won' : 'Lost'}
          </Typography>
        ) : (
          <Typography sx={{ color: getColorByDays(Number(row.daysInStage)) }}>
            {row.daysInStage !== null ? `${row.daysInStage} Days` : 'N/A'}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
